import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { CartItemComponent, CartItemContext, CartItemContextSource } from '@spartacus/storefront';
import { CartService } from '../../cart.service';
import { combineLatest, of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActiveCartService, RoutingService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { mergeMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { finalize } from 'rxjs/operators';
@Component({
  selector: '[cart-item-list-row]',
  templateUrl: './cart-item-list-row.component.html',
  styleUrls: ['./cart-item-list-row.component.scss'],
  providers: [
    CartItemContextSource,
    { provide: CartItemContext, useExisting: CartItemContextSource },
  ],
})
export class CartItemListRowEkComponent extends CartItemComponent implements OnInit {
  step = 1;
  allowZero: boolean = false;
  min: number = 1;
  max: number = 999;
  isBtnClicked: boolean = false;
  partialStock: boolean = false;
  lineItemError: string = '';
  imageData: any;

  @Input() isCheckoutPage: boolean = false;
  @Input() afterSimulateAction: boolean | undefined;
  @Output() qtyUpdateEvent = new EventEmitter<any>();
  @Output() itemRemoved = new EventEmitter<any>();
  @Input() item: any;
  @Input() itemLength: any;

  private destroy$ = new Subject<void>(); 
  private isRemovingItem: boolean = false;
  private removeDebouncer = new Subject<void>();
  private removingItems = {};
  private removeQueue: any[] = [];


  constructor(
    protected service: CartItemContextSource,
    private cd: ChangeDetectorRef,
    protected cartService: CartService,
    private userAccount: UserAccountFacade,
    private activeCart: ActiveCartService,
    public routingService: RoutingService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    super(service);
  }

  ngOnInit(): void {
    let images = this.item.product?.images?.PRIMARY;
    console.log(this.item.product);
    if (images) {
      localStorage.setItem('images', JSON.stringify(images));
    }
    this.imageData = localStorage.getItem('images');
    this.imageData = this.imageData ? JSON.parse(this.imageData) : {};
  }

  quantitySelect(e: any, item: any) {
    if (this.afterSimulateAction) {
      this.cartService.onButtonEnableDisable.next(false);
    }
    this.qtyUpdateEvent.emit(item);
    this.cd.detectChanges();
  }

  increment(item: any) {
    if (this.afterSimulateAction) {
      this.cartService.onButtonEnableDisable.next(false);
    }
    this.quantityControl.setValue(this.quantityControl.value + this.step);
    this.quantityControl.markAsDirty();
    this.qtyUpdateEvent.emit(item);
    this.cd.detectChanges();
  }

  decrement(item: any) {
    if (this.afterSimulateAction) {
      this.cartService.onButtonEnableDisable.next(false);
    }
    this.quantityControl.setValue(this.quantityControl.value - this.step);
    this.quantityControl.markAsDirty();
    this.qtyUpdateEvent.emit(item);
    this.cd.detectChanges();
  }

  isProductOutOfStock(product: any): boolean {
    return product && product.stock && product.stock.stockLevelStatus === 'outOfStock';
  }



removeItem() {
  if (!this.isBtnClicked && !this.isRemovingItem) {
    this.isBtnClicked = true;
    this.isRemovingItem = true;

    if (this.afterSimulateAction) {
      this.cartService.onButtonEnableDisable.next(false);
    }

    this.quantityControl.setValue(0);
    this.quantityControl.markAsDirty();

    
    this.removeQueue.push(this.item);

    
    this.processRemoveQueue();
  }
}


private processRemoveQueue() {
  setTimeout(() => {
    if (this.removeQueue.length > 0) {
      const item = this.removeQueue.shift(); 

      if (item) {
        if (this.itemLength === 1) {
          this.removeCart()
            .pipe(
              mergeMap((data) => {
                if (data.cartId && data.uid) {
                  return of(this.cartService.deleteCart(data.cartId, data.uid));
                } else {
                  return of(null);
                }
              })
            )
            .subscribe(
              () => {
                
                if (this.removeQueue.length > 0) {
                  this.processRemoveQueue();
                } else {
                  window.location.reload(true); 
                  this.isRemovingItem = false;
                }
              },
              (error) => {
                console.error('Error deleting cart:', error);
               
                if (this.removeQueue.length > 0) {
                  this.processRemoveQueue();
                } else {
                  this.isRemovingItem = false;
                }
              }
            );
        } else {
          this.itemRemoved.emit(item);
          
          if (this.removeQueue.length > 0) {
            this.processRemoveQueue();
          } else {
            this.isRemovingItem = false;
          }
        }
      }
    } else {
      
      this.isRemovingItem = false;
    }
  },1000); 
}






removeCart() {
  return combineLatest([this.userAccount.get(), this.activeCart.getActiveCartId()]).pipe(
    mergeMap(([{ uid }, cartId]: any) => {
      return of({ uid: uid, cartId: cartId });
    }),
    takeUntil(this.destroy$)
  );
}



ngOnDestroy(): void {
  this.destroy$.next();
  this.destroy$.complete();
}
}
